module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921034149_T.06ed1cd7.jpg";